import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-denials-prov',
  templateUrl: './denials-prov.component.html',
  styleUrls: ['./denials-prov.component.scss']
})
export class DenialsProvComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/billing-provider/denials-prov/denials-prov.component.ts